/** @jsx h */
import { $ } from 'utils/dom';
import { labels } from '../config';

const FilterContainer = ({ facetsActive, triggerAjaxSubmit }) => {
  function activeFilterClick(e) {
    const filterLabel = e.currentTarget.dataset.item;
    const targetCheckbox = $(`[data-label="${filterLabel}"]`);

    // find related checkbox and uncheck it before submit the form
    if (targetCheckbox) {
      targetCheckbox.checked = false;
    }
    triggerAjaxSubmit();
  }

  return (
    <fieldset className="form__fieldset">
      <legend className="form__legend form__legend--medium">
        {labels.search.filterActive}
      </legend>
      <ul className="input-filter-container">
        {facetsActive.selected.map(facet => {
          return (
            <li key={`${facet.facet}-${facet.item}`}>
              <button
                className="styled-button styled-button--filter-deselect"
                aria-controls={`${facet.facet}-${facet.item}`}
                data-facet={facet.facet}
                data-item={`${facet.name}-${facet.item}`}
                onClick={activeFilterClick}
                type="button"
              >
                <span className="styled-button__text">{facet.item}</span>
                <span className="styled-button__icon icon icon--cross">
                  <svg className="icon__svg" role="img" aria-hidden="true">
                    <use href="#icon-cross" />
                  </svg>

                  <span className="sr-only">Filter abwählen</span>
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
};

export default FilterContainer;
